$('.megafon-callback').on('click', function () {
    $('.itlcb-background-fill,.itlcb-widget-body').attr('style', 'display: block')
})


// WEBPACK FOOTER //
// ./scripts/components/callback/init.js